<style>
  #BtnDiv {
    position: fixed;
    bottom: 25px;
    left: 25px;
    background: #282a39b0;
    padding: 10px;
    border-radius: 5px;
  }

  .ModirEdit {
    font-weight: bolder;
    font-style: italic;
    text-decoration: underline;
  }
</style>

<div [hidden]="Show_History_View>0" class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">فرم صدور نامه</h5>

    <button type="button" *ngIf="Letter_Form_Id=='0' && Selected_DataList_LetterRequestCustomer_Record.id == 0"
      (click)="openModal_Customer(templateCustomer,0)" class="btn btn-warning" style="margin-left: 5px;"> جستجوی مشتری
      <i class="fa fa-vcard"></i> </button>
    <button type="button" *ngIf="Letter_Form_Id=='0'"
      (click)="openModal_LetterRequestCustomer(templateLetterRequestCustomer)" class="btn btn-danger"
      style="margin-left: 5px;"> پیوست به نامه <i class="fa fa-vcard"></i> </button>

    <button type="button" *ngIf="Letter_Form_Id=='0'"
      (click)="openModal_LetterRequestCustomerCopy(templateLetterRequestCustomerCopy)" class="btn btn-info"
      style="margin-left: 5px;"> کپی نامه صادره<i class="fa fa-copy"></i> </button>

    <br />
    <br />

    <div [hidden]="Data_Seleted_Customer.id==0">

      <form [formGroup]="AddNewLetter">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> شناسه درخواست </label>
            <input type="text" class="form-control" disabled value="{{Letter_Form_Code_Code}}" />
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> شماره نامه </label>
            <input type="text" class="form-control" disabled value="{{Letter_Form_Code}}" />
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">کد مشتری بهفا </label>
            <input type="text" class="form-control" disabled value="{{Data_Seleted_Customer.code}}" />
          </div>

        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">نام مشتری </label>
            <input type="text" class="form-control" disabled value="{{Data_Seleted_Customer.name}}" />
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">نام مشتری (انگلیسی) </label>
            <input type="text" class="form-control" disabled value="{{Data_Seleted_Customer.name_en}}" />
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-12">
            <label for="exampleInputEmail1"> <button type="button" [hidden]="Letter_Form_Id>'0'"
                (click)="openModal_CustomerAddress(templateCustomerAddress)" class="btn btn-danger"
                style="margin-left: 5px;"> آدرس محل استقرار دستگاه های مشتری </button> </label>
            <input type="text" class="form-control" disabled value="{{Data_Seleted_Address.address}}" />
          </div>
        </div>
        <br />
        <hr />
        <br />

        <div class="row">
          <div class="form-group col-md-3" [ngClass]="{'ModirEdit': Record_Letter.modirEdit_subject_id==true}">
            <label for="exampleInputEmail1"> موضوع نامه </label>
            <select class="custom-select" (change)="ReadData_Textletter()" formControlName="subject_id">
              <option value="0">انتخاب کنید</option>
              <option *ngFor="let item of DataList_SubjectLetter" [value]="item.id">{{item.title}}</option>
            </select>
          </div>
          <div class="form-group col-md-3" [ngClass]="{'ModirEdit': Record_Letter.modirEdit_sex==true}">
            <label for="exampleInputEmail1"> عنوان گیرنده </label>
            <select class="custom-select" formControlName="sex">
              <option value="0">سرکار خانم</option>
              <option value="1" selected>جناب آقای</option>
            </select>
          </div>
          <div class="form-group col-md-3" [ngClass]="{'ModirEdit': Record_Letter.modirEdit_giver_name==true}">
            <label for="exampleInputEmail1"> نام گیرنده </label>
            <input formControlName="giver_name" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_giver_name().valid && get_Form_giver_name().touched"
              class="form-text text-muted MyErrorRedColor">نام گیرنده را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-3" [ngClass]="{'ModirEdit': Record_Letter.modirEdit_giver_semat==true}">
            <label for="exampleInputEmail1"> سمت گیرنده </label>
            <input formControlName="giver_semat" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_giver_semat().valid && get_Form_giver_semat().touched"
              class="form-text text-muted MyErrorRedColor">سمت گیرنده را وارد نمائید.</small>
          </div>
        </div>
        <div class="row" *ngIf="!hiddenDetailAndPrice">

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> پیوست </label>
            <select class="custom-select" formControlName="peyvast">
              <option value="0">ندارد</option>
              <option value="1" selected>دارد</option>
            </select>
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> بازگشت به نامه شماره </label>
            <input formControlName="bazgashtBeNamehShomareh" type="text" class="form-control"
              placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_bazgashtBeNamehShomareh().valid && get_Form_bazgashtBeNamehShomareh().touched"
              class="form-text text-muted MyErrorRedColor">بازگشت به نامه شماره را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-4" *ngIf="Letter_Form_Id==0">
            <label for="exampleInputEmail1"> بازگشت به نامه با تاریخ </label>
            <input formControlName="bazgashtBeNamehTarikh" type="text" class="form-control"
              #datepickerbazgashtBeNamehTarikh placeholder="اینجا تایپ کنید ...">
            <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
              [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerbazgashtBeNamehTarikh"></ng-persian-datepicker>
          </div>

          <div class="form-group col-md-4" *ngIf="Letter_Form_Id>0">
            <label for="exampleInputEmail1"> بازگشت به نامه با تاریخ </label>
            <input formControlName="bazgashtBeNamehTarikh" disabled type="text" class="form-control"
              placeholder="اینجا تایپ کنید ...">
          </div>



        </div>

        <div class="row" *ngIf="!hiddenDetailAndPrice">
          <div class="form-group col-md-3" [ngClass]="{'ModirEdit': Record_Letter.modirEdit_takhfif==true}">
            <label for="exampleInputEmail1"> درصد تخفیف </label>
            <div class="row">
              <div class="form-group col-md-8">
                <input maxlength="2" formControlName="takhfif" type="number" class="form-control"
                  placeholder="اینجا تایپ کنید ...">
                <small *ngIf="!get_Form_takhfif().valid && get_Form_takhfif().touched"
                  class="form-text text-muted MyErrorRedColor">درصد تخفیف را وارد نمائید.</small>
              </div>
              <div class="form-group col-md-4">
                <input value="%" disabled style="font-weight: bolder;" type="text" class="form-control">
              </div>
            </div>



          </div>
          <div class="form-group col-md-3" [ngClass]="{'ModirEdit': Record_Letter.modirEdit_arsh_afzoodeh==true}">
            <label for="exampleInputEmail1"> ارزش افزوده </label>
            <div class="row">
              <div class="form-group col-md-8">
                <input maxlength="2" formControlName="arsh_afzoodeh" type="number" class="form-control"
                  placeholder="اینجا تایپ کنید ...">
                <small *ngIf="!get_Form_arsh_afzoodeh().valid && get_Form_arsh_afzoodeh().touched"
                  class="form-text text-muted MyErrorRedColor">ارزش افزوده را وارد نمائید.</small>
              </div>
              <div class="form-group col-md-4">
                <input value="%" disabled style="font-weight: bolder;" type="text" class="form-control">
              </div>
            </div>

          </div>
          <div class="form-group col-md-3" [ngClass]="{'ModirEdit': Record_Letter.modirEdit_pishPardakht==true}">
            <label for="exampleInputEmail1"> پیش پرداخت (ريال) </label>
            <input formControlName="pishPardakht" (keyup)="pishPardakht_Change()" type="number" class="form-control"
              placeholder="اینجا تایپ کنید ...">
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> پیش پرداخت (به حروف) </label>
            <input formControlName="pishPardakhtAlpah" disabled type="text" class="form-control">
          </div>
        </div>

        <div class="row" *ngIf="!hiddenDetailAndPrice">

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> هزینه خدمات (ريال) </label>
            <input formControlName="khadamat" (keyup)="khadamat_Change()" type="number" class="form-control"
              placeholder="اینجا تایپ کنید ...">
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> هزینه خدمات (به حروف) </label>
            <input formControlName="khadamatAlpah" disabled type="text" class="form-control">
          </div>
        </div>

        <div class="row" *ngIf="!hiddenDetailAndPrice">
          <div class="form-group col-md-12" [ngClass]="{'ModirEdit': Record_Letter.modirEdit_textletter_id==true}">
            <label for="exampleInputEmail1"> متن نامه </label>
            <select class="custom-select" formControlName="textletter_id">
              <option value="0">انتخاب کنید</option>
              <option *ngFor="let item of DataList_Textletter" [value]="item.id">{{item.dsc}}</option>
            </select>
          </div>
        </div>
      </form>

      <br />
      <hr />
      <br />

      <h5 *ngIf="!hiddenDetailAndPrice"> گیرنده فاکتور </h5>

      <button type="button" *ngIf="Letter_Form_Id=='0' || Letter_Draft_Form_Id>0"
        (click)="openModal_Customer(templateCustomer,1)" class="btn btn-warning" style="margin-left: 5px;"> جستجوی مشتری
        <i class="fa fa-vcard"></i> </button>

      <button type="button" *ngIf="Letter_Form_Id=='0' || Letter_Draft_Form_Id>0" (click)="Remove_ReciveCustomer()"
        class="btn btn-danger" style="margin-left: 5px;"> حذف مشتری <i class="fa fa-times-circle"></i> </button>
      <form *ngIf="!hiddenDetailAndPrice">
        <br />
        <br />
        <div class="row">

          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">نام مشتری </label>
            <input type="text" class="form-control" disabled value="{{Data_Seleted_ReciveCustomer.name}}" />
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> توضیحات گیرنده فاکتور </label>
            <input type="text" class="form-control" placeholder="اینجا تایپ کنید ..."
              [(ngModel)]="Data_Seleted_ReciveCustomer_Dsc" name="Data_Seleted_ReciveCustomer_Dsc" />
          </div>
        </div>
      </form>

      <br *ngIf="!hiddenDetailAndPrice" />
      <hr *ngIf="!hiddenDetailAndPrice" />
      <br *ngIf="!hiddenDetailAndPrice" />

      <div *ngIf="!hiddenDetailAndPrice">

        <h5> پیام های نامه </h5>

        <br />

        <form *ngIf="canEditMainForm" [formGroup]="MailMessageForm" (submit)="MailMessageForm_Submit()">

          <div class="row">
            <div class="form-group col-md-12">
              <label for="exampleInputEmail1"> پیام نامه </label>
              <select class="custom-select" formControlName="mailmessage_id">
                <option value="0">انتخاب کنید</option>
                <option *ngFor="let item of DataList_MailMessage" [value]="item.id">{{item.title}}</option>
              </select>
            </div>
          </div>

          <button type="submit" class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i>
            افزودن پیام </button>

        </form>




        <br />
        <br />

        <div class="table-responsive" *ngIf="FormAdded_MailMessage.length>0">


          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>پیام نامه</th>
                <th *ngIf="canEditMainForm">امکانات</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of FormAdded_MailMessage" [ngClass]="{'ModirEdit': item.del==true}">
                <td>{{FormAdded_MailMessage.indexOf(item)+1}}</td>
                <td>{{item.title}}</td>
                <td style="cursor: pointer;" *ngIf="canEditMainForm">
                  <a style="cursor: pointer;" (click)="MailMessageForm_Delete(FormAdded_MailMessage.indexOf(item))"
                    class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>
                </td>
              </tr>
            </tbody>
          </table>




        </div>

        <br />
        <br />

      </div>

      <br *ngIf="!hiddenDetailAndPrice" />
      <br *ngIf="!hiddenDetailAndPrice" />

      <div>

        <h5> ملاحظات </h5>

        <br />

        <form *ngIf="canEditMainForm">

          <div class="row">
            <div class="form-group col-md-12">
              <label for="exampleInputEmail1"> متن ملاحظه : </label>
              <input [(ngModel)]="FormAdded_Dsc_Input" name="FormAdded_Dsc_Input" type="text" class="form-control"
                placeholder="اینجا تایپ کنید ...">
            </div>
          </div>

          <button type="button" (click)="FormAdded_Dsc_Submit()" class="btn btn-success" style="margin-left: 5px;"><i
              class="fa  fa-plus-circle"></i> افزودن ملاحظه </button>

        </form>




        <br />
        <br />

        <div class="table-responsive" *ngIf="FormAdded_Dsc.length>0">


          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>پیام نامه</th>
                <th *ngIf="canEditMainForm">امکانات</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of FormAdded_Dsc"
                [ngClass]="{'ModirEdit': FormAdded_Dsc_Modir[FormAdded_Dsc.indexOf(item)]==true}">
                <td>{{FormAdded_Dsc.indexOf(item)+1}}</td>
                <td>{{item}}</td>
                <td style="cursor: pointer;" *ngIf="canEditMainForm">
                  <a style="cursor: pointer;" (click)="FormAdded_Dsc_Delete(FormAdded_Dsc.indexOf(item))"
                    class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>
                </td>
              </tr>
            </tbody>
          </table>




        </div>

        <br />
        <br />

      </div>

      <br />
      <br />

      <h5> دستگاه ها </h5>

      <br />
      <br />
      <form *ngIf="canEditMainForm" [formGroup]="DeviceForm" (submit)="DeviceForm_Submit()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-4" *ngIf="Edit_Device_Form_Index==-1">
            <label for="exampleInputEmail1"><button type="button" (click)="openModal_Device(templateDevice)"
                class="btn btn-warning left"> انتخاب دستگاه <i class="fa  fa-simplybuilt"></i> </button> </label>
            <input type="text" class="form-control" disabled value="{{Data_Seleted_Device_Record.title}}" />
          </div>
          <div class="form-group col-md-4" *ngIf="Edit_Device_Form_Index==-1">
            <label for="exampleInputEmail1"> عنوان فارسی </label>
            <select class="custom-select" formControlName="device_id">
              <option value="0">انتخاب کنید</option>
              <option *ngFor="let item of DataList_Devicepersian" [value]="item.id">{{item.dsc}}</option>
            </select>
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> محل کالیبراسیون </label>
            <select class="custom-select" formControlName="location">
              <option value="0">انتخاب کنید</option>
              <option value="1">محل مشتری</option>
              <option value="2">آزمایشگاه بهینه</option>
            </select>
          </div>
        </div>

        <div class="row">


          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">تعداد</label>
            <input formControlName="tedad" type="number" class="form-control" placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_DeviceForm_tedad().valid && get_DeviceForm_tedad().touched"
              class="form-text text-muted MyErrorRedColor">تعداد را وارد نمائید.</small>
          </div>


          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">ريال افزایش مدیر</label>
            <input formControlName="incRailModir" type="number" class="form-control" placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_DeviceForm_incRailModir().valid && get_DeviceForm_incRailModir().touched"
              class="form-text text-muted MyErrorRedColor">درصد افزایش مدیر را وارد نمائید.</small>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> مدت انقضاء </label>
            <select formControlName="Expiration" class="custom-select">
              <option value="0">انتخاب کنید</option>
              <option *ngFor="let item of Data_List_Expiration" [value]="item.id">{{item.title}}</option>
            </select>
          </div>

        </div>

        <div class="row">

          <div class="form-group col-md-12">
            <label for="exampleInputEmail1">توضیحات </label>
            <textarea formControlName="dscUser" class="form-control" placeholder="اینجا تایپ کنید ..."></textarea>

          </div>

        </div>

        <div class="row" *ngIf="Data_Seleted_Device_Record.title">
          <br />
          <div class="table-responsive">
            <table class="mb-0 table table-bordered table-3 text-center table-striped">
              <thead style="background-color: #39409b; color: white;">
                <tr>
                  <th>#</th>
                  <th>ملاحظه</th>
                  <th>مبلغ واحد(ريال)</th>
                  <th>امکانات</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of DataList_Tariff">
                  <td>{{DataList_Tariff.indexOf(item)+1}}</td>
                  <td style="text-align: right;">{{item.dsc}}</td>
                  <td>{{item.tariff|number}}</td>
                  <td>
                    <label *ngIf="selected_Tariff_Record.id!=item.id" for="exampleInputEmail1"><button type="button"
                        (click)="set_Selected_Tariff(item)" class="btn btn-danger left"> انتخاب </button> </label>
                    <p *ngIf="selected_Tariff_Record.id==item.id" style="color: red;">ملاحظه انتخاب شد</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>


        <div class="row">
          <br />
          <br />

          <button type="submit" [disabled]="!DeviceForm.valid" *ngIf="Edit_Device_Form_Index==-1"
            class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افزودن دستگاه </button>
          <button type="submit" [disabled]="!DeviceForm.valid" *ngIf="Edit_Device_Form_Index>-1" class="btn btn-info"
            style="margin-left: 5px;"><i class="fa  fa-edit"></i> ویرایش دستگاه </button>
          <button *ngIf="Edit_Device_Form_Index>-1" type="button" (click)="Cancel_DeviceFormList()"
            class="btn btn-danger" style="margin-left: 5px;"><i class="fa fa-times-rectangle"></i> لغو </button>
          <button type="button" *ngIf="Edit_Device_Form_Index==-1" (click)="Calc_DeviceFormListPriceTotal()"
            class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-calculate"></i> محاسبه فاکتور </button>

        </div>


      </form>


      <br />
      <br />

      <div class="table-responsive" style="max-height: 700px;"
        *ngIf="DeviceFormList.length>0 && Edit_Device_Form_Index==-1">
        <button (click)="exportexcel()" type="button" class="btn btn-warning" style="margin-left: 5px;"><i
            class="fa   fa-file-excel-o"></i> Excel </button>
        <br />
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>نام دستگاه</th>
              <th>محل کالیبراسیون</th>
              <th>تعداد</th>
              <th>مدت انقضاء</th>
              <th *ngIf="!hiddenDetailAndPrice">افزایش مدیر (درصد)</th>
              <th *ngIf="!hiddenDetailAndPrice">افزایش مدیر (ريال)</th>
              <th *ngIf="!hiddenDetailAndPrice">مبلغ واحد(ريال)</th>
              <th *ngIf="!hiddenDetailAndPrice">جمع کل(ريال)</th>
              <th>ملاحظات</th>
              <th>توضیحات</th>
              <th *ngIf="canEditMainForm">امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DeviceFormList" [ngClass]="{'ModirEdit': item.modirEdit==true}">
              <td>{{DeviceFormList.indexOf(item)+1}}</td>
              <td title="{{item.device_name_en}}">
                <span style="cursor: pointer;text-decoration: underline;">{{item.device_name}}</span>
              </td>

              <td>{{item.location_name}}</td>

              <td>
                <input *ngIf="canEditMainForm" (keyup)="Calc_DeviceFormListPriceTotal()" type="number"
                  [(ngModel)]="item.tedad" />
                <p *ngIf="!canEditMainForm">{{item.tedad}}</p>
              </td>

              <td>
                <select *ngIf="canEditMainForm" [(ngModel)]="item.expiration" class="custom-select">
                  <option *ngFor="let item of Data_List_Expiration" [value]="item.id">{{item.title}}</option>
                </select>
                <p *ngIf="!canEditMainForm">{{item.expiration_title}}</p>
              </td>


              <td *ngIf="!hiddenDetailAndPrice">
                <input *ngIf="canEditMainForm" type="number" (keyup)="Calc_IncreaseModir(false,item)"
                  [(ngModel)]="item.incPercentModir" />
                <p *ngIf="!canEditMainForm">{{item.incPercentModir|number}}</p>
              </td>
              <td *ngIf="!hiddenDetailAndPrice">
                <input *ngIf="canEditMainForm" type="number" (keyup)="Calc_IncreaseModir(true,item)"
                  [(ngModel)]="item.incRailModir" />
                <p *ngIf="!canEditMainForm">{{item.incRailModir|number}}</p>
              </td>


              <td *ngIf="!hiddenDetailAndPrice">{{item.price|number}}</td>
              <td *ngIf="!hiddenDetailAndPrice">{{( (item.price + item.incRailModir ) *item.tedad)|number}}</td>
              <td>{{item.price_dsc}}</td>
              <td>{{item.dscUser}}</td>

              <td *ngIf="canEditMainForm">
                <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                  <div class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      امکانات
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">

                      <a *ngIf="(DeviceFormList.indexOf(item)+1)!=1" style="cursor: pointer;"
                        (click)="Device_upgrade_First(DeviceFormList.indexOf(item))" class="dropdown-item"><i
                          class="fa fa-angle-double-up"></i> اولین </a>

                      <a *ngIf="(DeviceFormList.indexOf(item)+1)!=1" style="cursor: pointer;"
                        (click)="Device_upgrade(DeviceFormList.indexOf(item))" class="dropdown-item"><i
                          class="fa fa-angle-up"></i> بالا </a>

                      <a *ngIf="(DeviceFormList.indexOf(item)+1)!=DeviceFormList.length" style="cursor: pointer;"
                        (click)="Device_downgrade(DeviceFormList.indexOf(item))" class="dropdown-item"><i
                          class="fa fa-angle-down"></i> پایین </a>

                      <a *ngIf="(DeviceFormList.indexOf(item)+1)!=DeviceFormList.length" style="cursor: pointer;"
                        (click)="Device_downgrade_Last(DeviceFormList.indexOf(item))" class="dropdown-item"><i
                          class="fa fa-angle-double-down"></i> آخرین </a>

                      <a style="cursor: pointer;" (click)="EditDeviceFormList(DeviceFormList.indexOf(item))"
                        class="dropdown-item"><i class="fa fa-edit"></i> ویرایش </a>

                      <a style="cursor: pointer;"
                        (click)="DeleteDeviceFormList_Modal(templateRemoveDevice,DeviceFormList.indexOf(item))"
                        class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>
                    </div>
                  </div>
                </div>
              </td>

            </tr>

          </tbody>
          <tfoot style="position:sticky ;bottom: 0; background-color: #399b77;border: 1px solid #000;color: white;">
            <tr style="font-weight: bolder;text-decoration: underline;">

              <td colspan="4">
                دستگاه های در آزمایشگاه بهینه
              </td>
              <td *ngIf="hiddenDetailAndPrice" colspan="2">
                دستگاه های در آزمایشگاه بهینه
              </td>

              <td>
                {{DeviceCount_OutLocation|number}} مورد
              </td>
              <td>
                {{DevicePrice_OutLocation|number}} ريال
              </td>



              <td colspan="2">
                دستگاه های در محل مشتری
              </td>
              <td>
                {{DeviceCount_InLocation|number}} مورد
              </td>
              <td colspan="2">
                {{DevicePrice_InLocation|number}} ريال
              </td>

              <td *ngIf="canEditMainForm"></td>
            </tr>



            <tr *ngIf="!hiddenDetailAndPrice">
              <td colspan="6">
                جمع کل (ريال)
              </td>
              <td colspan="5">
                {{DeviceFormListPriceTotal|number}}
              </td>
              <td *ngIf="canEditMainForm"></td>
            </tr>
            <tr *ngIf="!hiddenDetailAndPrice">
              <td colspan="6">
                خدمات (ريال)
              </td>
              <td colspan="5">
                {{DeviceFormListKhadamatTotal|number}}
              </td>
              <td *ngIf="canEditMainForm"></td>
            </tr>
            <tr *ngIf="!hiddenDetailAndPrice">
              <td colspan="6">
                تخفیف (ريال)
              </td>
              <td colspan="5">
                {{DeviceFormListTakhfifTotal|number}}
              </td>
              <td *ngIf="canEditMainForm"></td>
            </tr>
            <tr *ngIf="!hiddenDetailAndPrice">
              <td colspan="6">
                ارزش افزوده (ريال)
              </td>
              <td colspan="5">
                {{DeviceFormListarsh_afzoodehTotal|number}}
              </td>
              <td *ngIf="canEditMainForm"></td>
            </tr>
            <tr *ngIf="!hiddenDetailAndPrice">
              <td colspan="6">
                مبلغ نهایی (ريال)
              </td>
              <td colspan="5">
                {{DeviceFormListPriceTotalTotal|number}}
              </td>
              <td *ngIf="canEditMainForm"></td>
            </tr>
          </tfoot>
        </table>
      </div>

      <br />
      <br />

      <div *ngIf="canEditPlannigForm || Schedule_DataList.length>0">

        <h5> برنامه‌ریزی </h5>

        <br />

        <form [formGroup]="ScheduleForm" (submit)="ScheduleForm_Submit()">

          <input *ngIf="canEditPlannigForm" type="hidden" formControlName="id" />

          <div *ngIf="canEditPlannigForm" class="row">

            <div class="form-group col-md-6">
              <label for="exampleInputEmail1"> تاریخ </label>
              <input type="text" #datepickerInputEnd formControlName="persianDate" placeholder="اینجا تایپ کنید ..."
                class="form-control" />
              <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
                [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
            </div>

            <div class="form-group col-md-3">
              <label for="exampleInputEmail1"> ساعت شروع </label>
              <select class="custom-select" formControlName="startHour">
                <option *ngFor="let item of HourList" [value]="item">{{item}} </option>
              </select>
            </div>

            <div class="form-group col-md-3">
              <label for="exampleInputEmail1"> ساعت پایان </label>
              <select class="custom-select" formControlName="endHour">
                <option *ngFor="let item of HourList" [value]="item">{{item}} </option>
              </select>
            </div>
            <div class="form-group col-md-3" style="display: none;">
              <label for="exampleInputEmail1"> انتشار نظرات تایید شده حیاتی </label>
              <select class="custom-select" formControlName="comment">
                <option value="1"> بله </option>
                <option value="0"> خیر </option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-12">
              <label for="exampleInputEmail1"> توضیحات </label>
              <textarea class="form-control" formControlName="dsc" placeholder="اینجا تایپ کنید ...">
              </textarea>
            </div>

          </div>

          <button *ngIf="canEditPlannigForm" type="submit" [disabled]="!ScheduleForm.valid" class="btn btn-success"
            style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افزودن تاریخ </button>

          <button type="button" *ngIf="!ShowDelete_Schedule" (click)="Set_ShowDelete_Schedule()" class="btn btn-danger"
            style="margin-left: 5px;"><i class="fa  fa-eye"></i> نمایش همه حکم ها </button>

          <button type="button" *ngIf="ShowDelete_Schedule" (click)="Set_ShowDelete_Schedule()" class="btn btn-danger"
            style="margin-left: 5px;"><i class="fa  fa-eye-slash"></i> عدم نمایش حکم های فعال </button>

        </form>




        <br />
        <br />

        <div class="table-responsive" *ngIf="Schedule_DataList.length>0">


          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>تاریخ</th>
                <th>ساعت</th>
                <th>توضیحات</th>
                <th>انتشار نظرات</th>
                <th>امکانات</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let item of Schedule_DataList">
                <tr *ngIf="(ShowDelete_Schedule || item.del==false)">
                  <td>{{Schedule_DataList.indexOf(item)+1}}</td>
                  <td>{{item.persianDate}}</td>
                  <td>از {{item.startDate}} تا {{item.endDate}}</td>
                  <td>{{item.dsc}}</td>
                  <td>
                    <p *ngIf="item.comment==1">بله</p>
                    <p *ngIf="item.comment==0">خیر</p>
                  </td>
                  <td style="cursor: pointer;"
                    *ngIf="canEditPlannigForm && !canCheckingPlaningForm && item.status!=true && item.del==false ">

                    <button type="button" (click)="openModal_ExpertCalibration(templateExpertCalibration,item)"
                      class="btn btn-danger" style="margin-left: 5px;"> کارشناس <i class="fa fa-user-circle-o"></i>
                    </button>

                    <button type="button" (click)="openModal_DeviceBehfa(templateDeviceBehfa,item)"
                      class="btn btn-warning left"> تجهیزات <i class="fa fa-building"></i> </button>


                    <a style="cursor: pointer;" (click)="ScheduleForm_Delete(Schedule_DataList.indexOf(item))"
                      class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>
                    <i *ngIf="item.sms" class="fa fa-envelope" style="color: blue;"></i>
                  </td>

                  <td style="cursor: pointer;" *ngIf="canCheckingPlaningForm && item.status!=true && item.del==false ">
                    <button type="button" (click)="openModal90(templateRequest90,1,item)" class="btn btn-success"
                      style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> تایید زمانبندی </button>
                    <a target="_blank" href="{{BaseUrl2}}{{item.id}}" class="btn btn-success"><i
                        class="fa fa-file-pdf-o"></i> PDF </a>
                    <i *ngIf="item.sms" class="fa fa-envelope" style="color: blue;"></i>
                  </td>

                  <td style="cursor: pointer;" *ngIf="item.status==true && item.del==false ">
                    <p style="color: blue">تایید برنامه ریزی</p>
                    <a target="_blank" href="{{BaseUrl2}}{{item.id}}" class="btn btn-success"><i
                        class="fa fa-file-pdf-o"></i> PDF </a>
                    <i *ngIf="item.sms" class="fa fa-envelope" style="color: blue;"></i>
                  </td>
                  <td style="cursor: pointer;"
                    *ngIf="!canEditPlannigForm && !canCheckingPlaningForm && item.status!=true && item.del==false">
                    <p style="color: orange">درحال بررسی</p>
                    <a target="_blank" href="{{BaseUrl2}}{{item.id}}" style="margin-left: 5px;"
                      class="btn btn-success"><i class="fa fa-file-pdf-o"></i> PDF </a>
                    <i *ngIf="item.sms" class="fa fa-envelope" style="color: blue;"></i>
                    <button *ngIf="Letter_Form_Id>0 && !InProccessing" (click)="Show_Activity_View(item)" type="button"
                      class="btn btn-warning" style="margin-left: 5px;"> <i class="fa fa-wpforms"></i> حکم
                      ماموریت</button>
                  </td>

                  <td style="cursor: pointer;" *ngIf="item.del==true">
                    <a target="_blank" href="{{BaseUrl2}}{{item.id}}" style="margin-left: 5px;"
                      class="btn btn-success"><i class="fa fa-file-pdf-o"></i> PDF </a>
                    <p style="color: red" *ngIf="item.done==null">حذف شده است</p>
                    <p style="color: red" *ngIf="item.done==false">ماموریت لغو شده</p>
                    <p style="color: green" *ngIf="item.done==true">ماموریت انجام شده</p>
                    <i *ngIf="item.sms" class="fa fa-envelope" style="color: blue;"></i>
                  </td>

                </tr>

                <tr *ngIf="item.expert.length>0 && (ShowDelete_Schedule || item.del==false)">
                  <td colspan="7">
                    <table class="mb-0 table table-bordered table-3 text-center table-striped">
                      <thead style="background-color: #396c9b; color: white;">
                        <tr>
                          <th>#</th>
                          <th>نام</th>
                          <th>نام خانوادگی</th>
                          <th>کد ملی</th>
                          <th>شماره همراه</th>
                          <th>نام پدر</th>
                          <th>سرپرست</th>
                          <th>امکانات</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let detail of item.expert">
                          <td>{{item.expert.indexOf(detail)+1}}</td>
                          <td>{{detail.name}}</td>
                          <td>{{detail.familly}}</td>
                          <td>{{detail.melicode}}</td>
                          <td>{{detail.shomareh_Hamreh}}</td>
                          <td>{{detail.name_Pedar}}</td>
                          <td>
                            <p *ngIf="detail.seleted">بله</p>
                            <p *ngIf="!detail.seleted">خیر</p>
                          </td>
                          <td *ngIf="canEditPlannigForm" style="cursor: pointer;">

                            <a *ngIf="!detail.seleted && detail.del==false" style="cursor: pointer;"
                              (click)="Change_Seleted_ExpertCalibration_Record(item,item.expert.indexOf(detail))"
                              class="dropdown-item"><i class="fa fa-check"></i> سرپرست </a>

                            <a style="cursor: pointer;" *ngIf="detail.del==false && item.del==false"
                              (click)="ExpertCalibration_Delete(item.expert.indexOf(detail),item)"
                              class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>

                            <p *ngIf="detail.del==true">حذف شده است</p>
                            <i *ngIf="detail.sms" class="fa fa-envelope" style="color: blue;"></i>
                          </td>
                          <td *ngIf="!canEditPlannigForm" style="cursor: pointer;">

                            <a style="cursor: pointer;"
                              *ngIf="detail.del==false && detail.visible==true && canDownloadPDFPlaning"
                              (click)="ExpertCalibration_Visible(detail)" class="dropdown-item"><i
                                class="fa fa-eye"></i> نمایش </a>

                            <a style="cursor: pointer;"
                              *ngIf="detail.del==false && detail.visible==false && canDownloadPDFPlaning"
                              (click)="ExpertCalibration_Visible(detail)" class="dropdown-item"><i
                                class="fa fa-eye-slash"></i> عدم نمایش </a>


                            <p *ngIf="detail.del==true">حذف شده است</p>
                            <i *ngIf="detail.sms" class="fa fa-envelope" style="color: blue;"></i>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                  </td>
                </tr>

                <tr *ngIf="item.deviceBehfa.length>0 && (ShowDelete_Schedule || item.del==false)">
                  <td colspan="7">
                    <table class="mb-0 table table-bordered table-3 text-center table-striped">
                      <thead style="background-color: #9b5539; color: white;">
                        <tr>
                          <th>#</th>
                          <th>شناسه سیستم</th>
                          <th>Description</th>
                          <th>Manufacturer</th>
                          <th>Model</th>
                          <th>Code BEHFA</th>
                          <th>امکانات</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let detail of item.deviceBehfa">
                          <td>{{item.deviceBehfa.indexOf(detail)+1}}</td>
                          <td>{{detail.code}}</td>
                          <td class="EnglishClm">{{detail.description}}</td>
                          <td class="EnglishClm">{{detail.manufacturer}}</td>
                          <td class="EnglishClm">{{detail.model}}</td>
                          <td class="EnglishClm">{{detail.codeBEHFA}}</td>
                          <td *ngIf="canEditPlannigForm" style="cursor: pointer;">
                            <a style="cursor: pointer;" *ngIf="detail.del==false && item.del==false"
                              (click)="DeviceBehfa_Delete(item.deviceBehfa.indexOf(detail),item)"
                              class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>

                            <p *ngIf="detail.del==true">حذف شده است</p>
                          </td>
                          <td *ngIf="!canEditPlannigForm" style="cursor: pointer;">
                            <p *ngIf="detail.del==true">حذف شده است</p>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                  </td>
                </tr>

              </ng-container>
            </tbody>
          </table>




        </div>

        <br />
        <br />


        <div>

          <h5> پیام های نامه زمان بندی </h5>

          <br />

          <form *ngIf="canEditPlannigForm" [formGroup]="MailMessageForm_Schedule"
            (submit)="MailMessageForm_Schedule_Submit()">

            <div class="row">
              <div class="form-group col-md-12">
                <label for="exampleInputEmail1"> پیام نامه </label>
                <select class="custom-select" formControlName="mailmessage_id">
                  <option value="0">انتخاب کنید</option>
                  <option *ngFor="let item of DataList_MailMessage_Schedule" [value]="item.id">{{item.title}}</option>
                </select>
              </div>
            </div>

            <button type="submit" class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i>
              افزودن پیام </button>

          </form>




          <br />
          <br />

          <div class="table-responsive" *ngIf="FormAdded_MailMessage_Schedule.length>0">


            <table class="mb-0 table table-bordered table-3 text-center table-striped">
              <thead style="background-color: #489b39; color: white;">
                <tr>
                  <th>#</th>
                  <th>پیام نامه</th>
                  <th *ngIf="canEditPlannigForm">امکانات</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of FormAdded_MailMessage_Schedule" [ngClass]="{'ModirEdit': item.del==true}">
                  <td>{{FormAdded_MailMessage_Schedule.indexOf(item)+1}}</td>
                  <td>{{item.title}}</td>
                  <td style="cursor: pointer;" *ngIf="canEditPlannigForm">
                    <a style="cursor: pointer;"
                      (click)="MailMessageForm_Schedule_Delete(FormAdded_MailMessage_Schedule.indexOf(item))"
                      class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>
                  </td>
                </tr>
              </tbody>
            </table>




          </div>

          <br />
          <br />

        </div>

      </div>

    </div>


    <br />
    <br />

    <div id="BtnDiv">

      <img *ngIf="Data_Seleted_Customer.id>0 && InProccessing" src="assets/Loading.gif" style="width: 25px;" />

      <ng-container *ngFor="let item of Data_List_Order">

        <button *ngIf="item.submit && !InProccessing " type="button" (click)="OpenOrderDialog(templateOrder,item)"
          [disabled]="!AddNewLetter.valid" [class]="item.cls" style="margin-left: 5px;"> <i [class]="item.icon"></i>
          {{item.title}} </button>
        <button *ngIf="item.hasRefer && !item.submit && !InProccessing" type="button"
          (click)="OpenOrderDialog(templateOrder,item)" [class]="item.cls" style="margin-left: 5px;"><i
            [class]="item.icon"></i> {{item.title}} </button>
        <button *ngIf="!item.hasRefer && !item.submit && !item.copy && !InProccessing" type="button"
          (click)="OpenOrderDialog(templateOrder,item)" [class]="item.cls" style="margin-left: 5px;"> <i
            [class]="item.icon"></i> {{item.title}} </button>
      </ng-container>

      <button type="button" *ngIf="Letter_Form_Id>0 && !InProccessing" (click)="openModal_Karshans(templateKarshans)"
        class="btn btn-info left" style="margin-left: 5px;"> <i class="fa fa-mobile-phone"></i> نماینده کالیبراسیون
      </button>

      <button *ngIf="has_calibration_customer_order && !InProccessing" type="button" class="btn btn-info"
        style="margin-left: 5px;">
        <i class="fa fa-info-circle"></i> درخواست فراخدمات
      </button>

      <button *ngIf="Letter_Form_Id>0 && !InProccessing" (click)="ReadHistory_Letter()" type="button"
        class="btn btn-warning" style="margin-left: 5px;"> <i class="fa fa-file-text"></i> جزئیات نامه </button>

      <button *ngIf="Letter_Form_Id>0 && !InProccessing" (click)="OpenNoteDialog(templateComment)" type="button"
        class="btn btn-success" style="margin-left: 5px;"> <i class=" fa fa-sticky-note-o"></i> ثبت نظر </button>

      <a target="_blank" *ngIf="canDownloadPDF && !InProccessing" href="{{BaseUrl}}{{Letter_Form_Id}}"
        style="margin-left: 5px;" class="btn btn-info"><i class="fa fa-file-pdf-o"></i> پیش نمایش </a>

      <a target="_blank" style="margin-left: 5px;" *ngIf="canDownloadPDFPlaning && !InProccessing"
        href="{{BaseUrl1}}{{Letter_Form_Id}}" class="btn btn-success"><i class="fa fa-file-pdf-o"></i> نامه اعلام زمان
      </a>

      <button *ngIf="canFillReviewForm && !InProccessing" (click)="Show_Review_View()" type="button"
        class="btn btn-danger" style="margin-left: 5px;"> <i class="fa fa-leanpub"></i> بازنگری</button>
    </div>

    <br />
    <br />



  </div>
</div>

<div *ngIf="Show_History_View==1" class="card card-statistics mb-30">

  <div class="card-body">
    <div class="tab nav-border" style="position: relative;">
      <div class="d-block d-md-flex justify-content-between">
        <div class="d-block w-100">
          <h5 class="card-title border-0 pb-0">جزئیات نامه '{{Letter_Form_Code}}'</h5>
        </div>
        <div class="d-block d-md-flex nav-tabs-custom">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active show" id="months-tab" data-toggle="tab" href="#order" role="tab"
                aria-controls="months" aria-selected="true">تاریخچه ارجاع</a>
            </li>
            <li class="nav-item">
              <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#mission" role="tab"
                aria-controls="months" aria-selected="true">پیوست نامه</a>
            </li>
            <li class="nav-item">
              <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#flowchart" role="tab"
                aria-controls="months" aria-selected="true">فلوچارت ارجاع</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="tab-content" id="myTabContent">

        <div class="tab-pane fade active show" id="order" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">
            <app-LetterRequestCustomerHistory [DataList_History]="DataList_History"></app-LetterRequestCustomerHistory>
          </div>
          <button *ngIf="!InProccessing && canDeleteHistoryRecord && DataList_Peyvast.length==1" type="button"
            (click)="DeleteLetterHistoryRecord()" class="btn btn-danger"><i class="fa fa-remove"></i>حدف آخرین
            ارجاع</button>
        </div>

        <div class="tab-pane fade show" id="mission" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">

            <app-LetterRequestCustomerPeyvast [canOpenPeyvast]="canOpenPeyvast" [DataList_Peyvast]="DataList_Peyvast">

            </app-LetterRequestCustomerPeyvast>

          </div>
        </div>

        <div class="tab-pane fade show" id="flowchart" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">

            <div>
              <app-LetterRequestCustomerTreeHistory [DataList_History]="DataList_History">
              </app-LetterRequestCustomerTreeHistory>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="card-body">
    <button (click)="Close_Show_History()" type="button" class="btn btn-warning" style="margin-left: 5px;"> بازگشت
    </button>
  </div>

</div>

<div *ngIf="Show_History_View==2" class="card card-statistics mb-30">

  <div class="card-body">
    <div class="tab nav-border" style="position: relative;">
      <div class="d-block d-md-flex justify-content-between">
        <div class="d-block w-100">
          <h5 class="card-title border-0 pb-0"> حکم ماموریت '{{Selected_LetterRequestCustomer_Schedule.id}}' در تاریخ
            <span style="display: inline-block;">{{Selected_LetterRequestCustomer_Schedule.persianDate}}</span> از ساعت
            {{Selected_LetterRequestCustomer_Schedule.startDate}} تا {{Selected_LetterRequestCustomer_Schedule.endDate}}
          </h5>
          <h5 class="card-title border-0 pb-0"> نامه شماره '{{Letter_Form_Code}}'</h5>

        </div>
        <div class="d-block d-md-flex nav-tabs-custom">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active show" id="months-tab" data-toggle="tab" href="#order" role="tab"
                aria-controls="months" aria-selected="true">فرم ثبت وقایع</a>
            </li>
            <li class="nav-item">
              <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#mission" role="tab"
                aria-controls="months" aria-selected="true">وقایع ثبت شده</a>
            </li>
            <li class="nav-item">
              <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#flowchart" role="tab"
                aria-controls="months" aria-selected="true">دستگاه‌ها</a>
            </li>
            <li class="nav-item">
              <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#form" role="tab" aria-controls="months"
                aria-selected="true">فرم حکم ماموریت</a>
            </li>
            <li class="nav-item">
              <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#karshnas" role="tab"
                aria-controls="months" aria-selected="true">نماینده کالیبراسیون </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade active show" id="order" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">

            <div class="form-group col-md-12">
              <app-LetterRequestCustomerMissionActivity [inner_Letter_id]="Selected_LetterRequestCustomer_Schedule.id"
                [inner_Customer_id]="Data_Seleted_Customer.id">

              </app-LetterRequestCustomerMissionActivity>
            </div>



          </div>

        </div>
        <div class="tab-pane fade show" id="mission" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">

            <div class="form-group col-md-12">
              <app-LetterRequestCustomerMissionActivityList
                [inner_Letter_id]="Selected_LetterRequestCustomer_Schedule.id"
                [inner_Customer_id]="Data_Seleted_Customer.id">

              </app-LetterRequestCustomerMissionActivityList>
            </div>

          </div>
        </div>
        <div class="tab-pane fade show" id="flowchart" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">

            <div class="form-group col-md-12">
              <app-LetterRequestCustomerMissionActivityDevice
                [inner_Letter_id]="Selected_LetterRequestCustomer_Schedule.id">

              </app-LetterRequestCustomerMissionActivityDevice>
            </div>

          </div>
        </div>
        <div class="tab-pane fade show" id="form" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">

            <div class="form-group col-md-12">
              <app-LetterRequestCustomerMissionActivityForm
                [inner_Letter_id]="Selected_LetterRequestCustomer_Schedule.id"
                [inner_Customer_id]="Data_Seleted_Customer.id">

              </app-LetterRequestCustomerMissionActivityForm>
            </div>

          </div>
        </div>
        <div class="tab-pane fade show" id="karshnas" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">

            <div class="form-group col-md-12">
              <app-CutomerKarshnas [inner_Customer]="Data_Seleted_Customer.id">

              </app-CutomerKarshnas>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card-body">
    <button (click)="Close_Show_History()" type="button" class="btn btn-warning" style="margin-left: 5px;"> بازگشت
    </button>
    <a target="_blank" href="{{BaseUrl3}}{{Selected_LetterRequestCustomer_Schedule.id}}" style="margin-left: 5px;"
      class="btn btn-info"><i class="fa fa-file-pdf-o"></i> PDF</a>
  </div>
</div>

<div *ngIf="Show_History_View==3" class="card card-statistics mb-30">

  <div class="card-body">
    <div class="row mb-30">
      <div class="form-group col-md-12">
        <h5 class="card-title border-0 pb-0">فرم بازنگری نامه '{{Letter_Form_Code}}'</h5>
        <app-LetterRequestCustomerReviewAnswer [inner_Letter_id]="Letter_Form_Id">

        </app-LetterRequestCustomerReviewAnswer>
      </div>

    </div>
  </div>

  <div class="card-body">
    <button (click)="Close_Show_History()" type="button" class="btn btn-warning" style="margin-left: 5px;"> بازگشت
    </button>

  </div>
</div>


<ng-template #templateCustomer>
  <div class="modal-header">
    <h4 class="modal-title pull-left">لیست اطلاعات مشتری </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Customer.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">نام مشتری </label>
          <input type="text" class="form-control" (keyup)="ReadData_Customer_KeySearch()"
            [(ngModel)]="Search_CodeName_Customer_Table" placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>کد مشتری بهفا</th>
              <th>نام مشتری</th>
              <th>نام مشتری (انگلیسی)</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Customer
            | paginate
                    : {
                        id: 'DataList_Customer',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_Customer).length
                      }">
              <td>{{DataList_Customer.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.name}}</td>
              <td>{{item.name_en}}</td>
              <td (click)="Set_Selected_Customer_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingCustomer" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingCustomer" type="button" (click)="ReadData_Customer()" class="btn btn-info"
      style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Customer.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateCustomerAddress>
  <div class="modal-header">
    <h4 class="modal-title pull-left">لیست آدرس های مشتری </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_CustomerAdress.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>عنوان آدرس</th>
              <th>آدرس</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Address">
              <td>{{DataList_Address.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td>{{item.address}}</td>
              <td (click)="Set_Data_Seleted_Address(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingCustomer" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingCustomer" type="button" (click)="ReadData_Initial_Customer()" class="btn btn-info"
      style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_CustomerAdress.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateExpertCalibration>
  <div class="modal-header">
    <h4 class="modal-title pull-left">لیست کارشناس کالیبراسیون </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_ExpertCalibration.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">نام خانوادگی</label>
          <input [(ngModel)]="Filter_Familly" (keyup)="Change_Filter()" name="Filter_Familly" type="text"
            class="form-control" placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>نام</th>
              <th>نام خانوادگی</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_ExpertCalibration
            |filter:Filter_Familly:'familly'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: ExpertCalibrationpage,
                        totalItems: (DataList_ExpertCalibration
                        |filter:Filter_Familly:'familly'
                        ).length
                      }
            ">
              <td>{{DataList_ExpertCalibration.indexOf(item)+1}}</td>
              <td>{{item.name}}</td>
              <td>{{item.familly}}</td>
              <td (click)="Set_Selected_ExpertCalibration_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="Procssing_ExpertCalibration" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!Procssing_ExpertCalibration" type="button" (click)="ReadData_ExpertCalibration()"
      class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_ExpertCalibration.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateDevice>
  <div class="modal-header">
    <h4 class="modal-title pull-left">لیست اطلاعات دستگاه ها </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Device.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> نام دستگاه </label>
          <input type="text" class="form-control" (keyup)="ReadData_Device_KeySearch()"
            [(ngModel)]="Search_Name_Device_Table" placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>نام دستگاه</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Device
            | paginate
                    : {
                        id: 'DataList_Device',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_Device).length
                      }">
              <td>{{DataList_Device.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td (click)="Set_Selected_Device_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingDevice" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingDevice" type="button" (click)="ReadData_Device()" class="btn btn-info"
      style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Device.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateCode>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> شماره نامه </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Code.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <p>شماره نامه <b>'{{Letter_Form_Code}}'</b></p>
  </div>
  <div class="modal-body" *ngIf="canShowSendSMS">
    <div class="table-responsive">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>نام و نام خانوادگی</th>
            <th>سمت</th>
            <th>شماره تلفن همراه</th>
            <th>توضیحات</th>
            <th>امکانات</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of DataList_Karshnash">
            <td>{{DataList_Karshnash.indexOf(item)+1}}</td>
            <td>
              <span *ngIf="item.sex==1">آقای</span>
              <span *ngIf="item.sex==0">خانم</span>
              {{item.fname}} {{item.lname}}
            </td>
            <td>{{item.semat}}</td>
            <td>{{item.mobile}}</td>
            <td>{{item.dsc}}</td>
            <td>
              <button type="button" *ngIf="!item.del" class="btn btn-danger"
                (click)="Change_Selected_Of_Karshnash(item)">عدم انتخاب</button>
              <button type="button" *ngIf="item.del" class="btn btn-info" (click)="Change_Selected_Of_Karshnash(item)">
                انتخاب</button>
            </td>

          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer">

    <button type="button" *ngIf="canShowSendSMS" class="btn btn-success" (click)="SendSMS()">ارسال پیامک</button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Code.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateKarshans>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> شماره تلفن همراه نماینده کالیبراسیون </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Karshans.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="table-responsive">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>نام و نام خانوادگی</th>
            <th>سمت</th>
            <th>شماره تلفن همراه</th>
            <th>توضیحات</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of DataList_Karshnash">
            <td>{{DataList_Karshnash.indexOf(item)+1}}</td>
            <td>
              <span *ngIf="item.sex==1">آقای</span>
              <span *ngIf="item.sex==0">خانم</span>
              {{item.fname}} {{item.lname}}
            </td>
            <td>{{item.semat}}</td>
            <td>{{item.mobile}}</td>
            <td>{{item.dsc}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_Karshans.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateLetterRequestCustomer>
  <div class="modal-header">
    <h4 class="modal-title pull-left">لیست اطلاعات نامه </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_LetterRequestCustomer.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> شماره نامه </label>
          <input type="text" class="form-control" [(ngModel)]="Search_code_LetterRequestCustomer"
            placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> موضوع نامه </label>
          <input type="text" class="form-control" [(ngModel)]="Search_persianDate_LetterRequestCustomer"
            placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">نام مشتری </label>
          <input type="text" class="form-control" [(ngModel)]="Search_customer_LetterRequestCustomer"
            placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>شماره نامه</th>
              <th>نوع نامه</th>
              <th>نام مشتری</th>
              <th>موضوع نامه </th>
              <th>نام گیرنده</th>
              <th>سمت گیرنده</th>
              <th>کاربر فرستنده</th>
              <th>کاربر گیرنده</th>
              <th>وضیعت</th>
              <th>پیام</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_LetterRequestCustomer
            |filter:Search_persianDate_LetterRequestCustomer:'subject_name'
            |filter:Search_customer_LetterRequestCustomer:'customer'
            |filter:Search_code_LetterRequestCustomer:'code'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_LetterRequestCustomer
                        |filter:Search_persianDate_LetterRequestCustomer:'subject_name'
                        |filter:Search_code_LetterRequestCustomer:'code'
                        |filter:Search_customer_LetterRequestCustomer:'customer').length
                      }
            ">
              <td>{{DataList_LetterRequestCustomer.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.letterType}}</td>
              <td>{{item.customer}}</td>
              <td>{{item.subject_name}}</td>
              <td>{{item.giver_name}}</td>
              <td>{{item.giver_semat}}</td>
              <td>{{item.lastSender}}</td>
              <td>{{item.lastGiver}}</td>
              <td>{{item.lastSection}}</td>
              <td>{{item.lastOrder}}</td>
              <td (click)="Set_Selected_LetterRequestCustomer(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="Procssing_LetterRequestCustomer" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!Procssing_LetterRequestCustomer" type="button" (click)="ReadData_LetterRequestCustomer()"
      class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_LetterRequestCustomer.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateLetterRequestCustomerCopy>
  <div class="modal-header">
    <h4 class="modal-title pull-left">کپی نامه صادره</h4>
    <button type="button" class="close pull-right" aria-label="Close"
      (click)="modalRef_LetterRequestCustomerCopy.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> شماره نامه </label>
          <input type="text" class="form-control" [(ngModel)]="Search_code_LetterRequestCustomerCopy"
            placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>

      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="Procssing_LetterRequestCustomerCopy" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!Procssing_LetterRequestCustomer" type="button" (click)="Copy_LetterRequestCustomer()"
      class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_LetterRequestCustomerCopy.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateOrder>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> {{Selected_Order_Operation.title}} </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Order.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12" *ngIf="Selected_Order_Operation.hasRefer || Selected_Order_Operation.submit">
        <label for="exampleInputEmail1">گیرنده</label>
        <select class="custom-select" [(ngModel)]="SelectedLetterRole">
          <option value="0">انتخاب کنید</option>
          <option *ngFor="let item of Data_list_LetterRole" [value]="item.id">{{item.title}}</option>
        </select>
      </div>
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">توضیحات</label>
        <input type="text" class="form-control" [(ngModel)]="LetterHistoryDsc" placeholder="اینجا تایپ کنید ...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success"
      (click)="SubmitAddNewLetter_Co(templateCode,templateLetterTarrifFloor,Selected_Order_Operation)"> ارسال و ثبت
    </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Order.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateRequest90>
  <div class="modal-header">
    <h4 *ngIf="statusFunction==1" class="modal-title pull-left"> تایید اطلاعات برنامه ریزی </h4>
    <h4 *ngIf="statusFunction==2" class="modal-title pull-left">عدم تایید اطلاعات برنامه ریزی </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Request90.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-footer">
    <button *ngIf="statusFunction==1" type="button" class="btn btn-warning" (click)="ChangeStatus_Request90()"> تایید
      اطلاعات <i class="fa fa-check"></i></button>
    <button *ngIf="statusFunction==2" type="button" class="btn btn-warning" (click)="ChangeStatus_Request90()"> عدم
      تایید اطلاعات <i class="fa fa-times-circle"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Request90.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateComment>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> ثبت نظر جدید برای مشتری '{{Data_Seleted_Customer.name}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Note.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">شرح</label>
        <textarea type="text" class="form-control" [(ngModel)]="Note_Dsc" placeholder="اینجا تایپ کنید ...">
        </textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" *ngIf="!InProccessing" class="btn btn-success" (click)="SubmitNote()">
      ارسال و ثبت </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Note.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateDeviceBehfa>
  <div class="modal-header">
    <h4 class="modal-title pull-left">لیست اطلاعات تجهیزات بهفا </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_DeviceBehfa.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <app-DeviceBehfaActiveList [inner_PersianDate]="Proccessing_Schedule.persianDate"
      [inner_SeletedDeviceBehfa]="this.Proccessing_Schedule.deviceBehfa"
      (seleted_DeviceBehfa_Interface)="Set_Selected_DeviceBehfa_Record($event,templateDeviceBehfaSchedule)">

    </app-DeviceBehfaActiveList>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_DeviceBehfa.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateRemoveDevice>
  <div class="modal-header">
    <h4 class="modal-title pull-left">تایید حذف دستگاه '{{DeleteDeviceFormList_Record.device_name}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_DeleteDeviceFormList.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="DeleteDeviceFormList()"> حذف دستگاه <i
        class="fa fa-remove"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_DeleteDeviceFormList.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateDeviceBehfaSchedule>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> هشدار </h4>
    <button type="button" class="close pull-right" aria-label="Close"
      (click)="Set_Selected_DeviceBehfa_Record_Co(templateDeviceBehfa,0)">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <p *ngFor="let item of DataList_DeviceBehfa_Schedule">{{item.replace('-','/')}}</p>
  </div>


  <div class="modal-footer">
    <button type="button" class="btn btn-success"
      (click)="Set_Selected_DeviceBehfa_Record_Co(templateDeviceBehfa,1)">تایید و افزودن</button>
    <button type="button" class="btn btn-danger"
      (click)="Set_Selected_DeviceBehfa_Record_Co(templateDeviceBehfa,1)">لغو</button>
  </div>
</ng-template>

<ng-template #templateLetterTarrifFloor>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> تایید انجام عملیات </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_TarrifFloor.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">

        <span>
          {{TarrifFloorDsc}}
        </span>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="LetterTarrifFloor()"> تایید انجام کار </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_LetterTarrifFloor.hide()">بستن</button>
  </div>
</ng-template>


<table id="excel-table" style="display: none;">
  <thead>
    <tr>
      <th>#</th>
      <th>نام دستگاه</th>
      <th>محل کالیبراسیون</th>
      <th>تعداد</th>
      <th>مدت انقضاء</th>
      <th>ريال افزایش مدیر</th>
      <th>مبلغ واحد(ريال)</th>
      <th>جمع کل(ريال)</th>
      <th>ملاحظات</th>
      <th>توضیحات</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DeviceFormList">
      <td>{{DeviceFormList.indexOf(item)+1}}</td>
      <td>{{item.device_name}}</td>
      <td>{{item.location_name}}</td>
      <td>{{item.tedad}}</td>
      <td>{{item.expiration_title}}</td>
      <td>{{item.incRailModir|number}}</td>
      <td>{{item.price|number}}</td>
      <td>{{( (item.price + item.incRailModir ) *item.tedad)|number}}</td>
      <td>{{item.price_dsc}}</td>
      <td>{{item.dscUser}}</td>
    </tr>

  </tbody>

</table>